import Rule from "../Rule";

export default class RuleOASetupDateRequiredBeforeMovingToSetup extends Rule {
    static message = "A Setup Date is required before moving to Setup.";

    run() {

        const currentOrderActivity = this.currentChartData.orderActivity[this.orderActivityId];
        const futureOrderActivity = this.futureChartData.orderActivity[this.orderActivityId];

        if (
            [0, 1, 2].includes(currentOrderActivity.status) &&
            futureOrderActivity.status === 3 &&
            futureOrderActivity.setupDate === null
        ) {
            return this.fail();
        }
        else {
            return this.pass();
        }
    }
}